module.exports = __webpack_public_path__ + "img/empty.454d8f86.svg";